var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"c0"},[_c('span',{staticClass:"c1 c2",domProps:{"innerHTML":_vm._s(_vm.$t('legal.privacyPolicy.content'))}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }